import { useState, useEffect } from 'react';
import { lessonService } from '../services/lessonService';

export const useLesson = (lessonId) => {
    const [lesson, setLesson] = useState(null);
    const [resources, setResources] = useState([]);
    const [experiment, setExperiment] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (lessonId) {
            fetchLessonData();
        }
    }, [lessonId]);

    const fetchLessonData = async () => {
        try {
            setLoading(true);
            const [lessonData, resourcesData, experimentData] = await Promise.all([
                lessonService.getLessonById(lessonId),
                lessonService.getLessonResources(lessonId),
                lessonService.getLessonExperiment(lessonId).catch(() => null)
            ]);

            setLesson(lessonData.lesson);
            setResources(resourcesData.resources);
            setExperiment(experimentData?.experiment);
        } catch (err) {
            setError(err.message || 'Failed to fetch lesson data');
        } finally {
            setLoading(false);
        }
    };

    const startLesson = async () => {
        try {
            await lessonService.startLesson(lessonId);
        } catch (err) {
            console.error('Failed to start lesson:', err);
        }
    };

    const completeLesson = async (timeSpent) => {
        try {
            await lessonService.completeLesson(lessonId, timeSpent);
        } catch (err) {
            console.error('Failed to complete lesson:', err);
        }
    };

    return {
        lesson,
        resources,
        experiment,
        loading,
        error,
        startLesson,
        completeLesson,
        refetch: fetchLessonData
    };
};